import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=214c9272&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=214c9272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c9272",
  null
  
)

export default component.exports